import {supabase} from "../utils/supabaseClient";

interface Tournament {
    id: number
    name: string
    fk_parent: number
    suggested_start_date: string
    suggested_end_date: string
    actual_start_date: string
    actual_end_date: string
    age_group: string
    gender: string
    logo: string
    short_name: string
    type: string
    season: Season
    teams_type: string
}

interface Season {
        id: number
        name: string
    }
const getTournaments = async(): Promise<Tournament[]> =>  {
    try {
        const { data, error } = await supabase
            .from('tournaments')
            .select(`
                id,
                name,
                fk_parent,
                suggested_start_date,
                suggested_end_date,
                actual_start_date,
                actual_end_date,
                age_group,
                gender,
                logo,
                short_name,
                type,
                season: seasons!tournaments_fk_season_fkey (
                    id,
                    name
                    ),
                teams_type
            `)
            .eq ('type', 'Tournament')

        if (error) {
            console.error('Tournament Error:', error);
            throw error;
        }

        const tournaments: Tournament[] = data.map((item: any) => ({
            ...item,
            season: item.season
        }));

        console.log('All tournaments:', tournaments);

        return tournaments;

    } catch(error) {
        console.error('Error fetching tournaments:', error);
        throw error;
    }
}

export default getTournaments;